import { AppThunk } from "../../../state/store"
import { initSettings } from "./slice"
import { InitSettingsInput } from "./types"

export const initializeSettings = (
  input: InitSettingsInput
): AppThunk => async (dispatch) => {
  dispatch(initSettings(input))
}
